import { render, staticRenderFns } from "./PasswordC.vue?vue&type=template&id=00c31393"
import script from "./PasswordC.vue?vue&type=script&lang=js"
export * from "./PasswordC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports